import React from "react";
import styled from "styled-components";
import { Flex, Button } from "../../components";
import { history } from "../../utils";
const TestDescriptionWrapper = styled.div`
  display: grid;
 
  margin-bottom: 2rem;
  img {
    width: 100%;
  }
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;

const Name = styled.h1`
  @media(max-width:767px){
    font-size:20px;
  }
`
const H3 = styled.h3`
  @media(max-width:767px){
    font-size:16px;
  }
`


  
function checkNative(){
  try {
    if((window.webkit) || window.appInterface)
    return true;
    else return false;
  } catch (error) {
    console.log(error);
  }
}


function openFullscreen(tid) {
  try {
    var elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }
    history.push(`/vpt/test/${tid}/0`);
  } catch (error) {
    console.log(error);
  }
}

function callbackToNative(msg){
  try {
    if (window.webkit != undefined) {
      window.webkit.messageHandlers.observe.postMessage(msg);
      window.webkit.messageHandlers.appInterface.postMessage(msg)
    }
    if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg)
    }
  } catch (error) {
    console.log(msg);
    console(error);
  }
}
const TestDescription = ({ tid, name, test_img, timelimit, description,questions_count, results }) => (

  
  <div style={{padding:'20px'}}>
    <div>
      <a href="https://edwisely.com">
          <img src="/images/Edwisely_logo.svg" height="50"/>
      </a>
    </div>
      <Flex column center>
    {name ?
    <div>
     
      <TestDescriptionWrapper>
        <Name>{name}</Name>
        <Flex column>
          <H3>Total questions : {questions_count}  </H3>
          <H3>Duration of the test</H3>
          <p>{parseFloat(timelimit).toFixed() / 60} minutes</p>
          
          <div>
            <H3>Instructions:</H3>
            <ul>
              <li>
                The test will contain Multiple Choice Questions(MCQs) with a single correct answer.
              </li>
              <li>
                There is no negative marking for the incorrectly answered questions.
              </li>
              <li>
                One point will be awarded for each correctly answered question.
              </li>
              <li>
                The test will be auto-submitted once the allocated duration of the test completes.
              </li>
              <li>
                The results for the test will auto-appear once the test gets expired.
              </li>
              <li>
                The detailed report for the test will be displayed in the results page and mailed to you at the email id mentioned at the time of registration.
              </li>
              <li>
                On the test report page, you will get a percentile score for each trait being measured.
              </li>
              <li>
                Definitions of every trait is mentioned below the report.
              </li>
              <li>
                In cases of any discrepancies, please send an email to <b> <a href="mailto:hello@edwisely.com">hello@edwisely.com</a> </b> mentioning the issue in detail. We will get back to you with 1-2 working days regarding the same.
              </li>
              <li><b>WARNING:  You are not allowed to take any screenshots during the test, this may effect your scores. </b> </li>
              <li><b> WARNING: You are not allowed to take switch the tab or browser. Any attempt to do so will lead to auto-submission of the test.</b></li>
              <li style={{color:'red'}}><b>WARNING: You are required to answer a minimum of 5 questions in order to generate your test report.</b></li>
            </ul>
          </div>
        </Flex>
      </TestDescriptionWrapper>
      <Flex column justifyBetween alignCenter>
          <Button  onClick={()=>openFullscreen(tid)}  small>{results ? `Show answers` : `START TEST`}</Button>
      </Flex>
      <div className="prvc">
          <span><a href="https://www.edwisely.com/privacy.html" target="_blank">Privacy policy </a>
          &nbsp;&nbsp;&nbsp;&nbsp;
          
          <a href="https://www.edwisely.com/tos.html" target="_blank">Terms &amp; Conditions</a></span><br/>
      </div>
      <div style={{textAlign:'center',marginTop:'-10px'}}>
       <span style={{color:'#000000',fontSize: '14px'}}>All Rights Reserved. © 2019  Edwisely. Copyright of Hakate Technologies Pvt. LTD</span>
      </div>
      
    </div>
      :
      <h3>Something went wrong try again later</h3>
      }
    
  </Flex>
  <style jsx="true">{`
    .prvc{
      margin-top:20px;
      margin-bottom: 30px;    
      text-align:center;
    }
    .prvc span a{
      text-decoration:underline;
      font-size: 12px;
    }
  `}
    


  </style>
  </div>
  
  
);

export default TestDescription;
